import React from 'react';
import { useIntl } from 'react-intl';

import { SimpleCallback } from '../../../typings';
import { Button } from '../../button/button';
import { UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import { H2 } from '../../header-text/header-text';
import Image from '../../image/image';
import { SimpleText } from '../../simple-text/simple-text';
import Text from '../../text/text';

import './quiz__finisher.scss';

interface Props {
    handleRestartQuiz: SimpleCallback;
}

export const QuizFinisher = (props: Props) => {
    const { handleRestartQuiz } = props;
    const intl = useIntl();

    return (
        <div className="quiz-teacher__finisher">
            <Image
                alt="finisher"
                className="quiz-teacher__finisher-image"
                disableSrcSet={true}
                src={intl.formatMessage({ id: 'quiz.teacher.new.finisher' })}
            />
            <H2
                id="quiz.endingMessage"
                mix="quiz-teacher__finisher-title"
                typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMMedium}
            />
            <Text id="quiz.whatsNext" typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular} />
            <Button className="quiz-teacher__finisher-btn" onClick={handleRestartQuiz} view={Button.VIEW.ACTION}>
                <SimpleText id="quiz.action.restart" />
            </Button>
        </div>
    );
};
